import { DATAFEED } from "../../Services/fake/datafeed";

export const print = (...x) => console.log.apply(null, ['>>>> TC', ...x]);
const historyLast = {};
const isTradeList = false;

const resolutionToSeconds = (r) => {
  const minutes = parseInt(r, 10);
  if (r === '1D') {
    return 1440;
  }
  if (r === 'D') {
    return 4320;
  }
  if (!isNaN(minutes)) {
    return minutes;
  }
  return 1;
};

const config = {
  supports_time: true,

  supported_resolutions: [
    '1',
    '5',
    '15',
    '30',
    '60',
    '120',
    '240',
    '360',
    '720',
    '1d',
    '3d',
    'w',
    'm',
  ],
};

export const dataFeedObject = (tradingChart, markets, pricescaleValue, currentMarket) => {
  const dataFeed = {
    onReady: (cb) => {
      setTimeout(() => cb(config), 0);
    },

    searchSymbols: (userInput, exchange, symbolType, onResultReadyCallback) => {
      const symbols = markets.map((m) => ({
        symbol: m.pairsCombined, // "xrpusdt"
        full_name: m.pairs, // "USDT_XRP"
        description: m.pairs, // "USDT_XRP"
        ticker: m.pairsCombined, // "xrpusdt"
        type: 'bitcoin',
      }));

      setTimeout(() => onResultReadyCallback(symbols), 0);
    },
    resolveSymbol: (symbolName, onSymbolResolvedCallback, onResolveErrorCallback) => {
      // expects a symbolInfo object in response
      const symbol = markets.find((m) => m.pair_key === currentMarket.toLowerCase());
      if (!symbol) {
        return setTimeout(() => onResolveErrorCallback('Symbol not found'), 0);
      }

      const symbolStub = {
        name: symbol?.pairs.replace('_', '/').toUpperCase(), // "btc_usdt"
        description: '',
        type: 'bitcoin',
        session: '24x7',
        timezone: 'Etc/UTC',
        ticker: symbol?.pairs.replace('_', '/').toUpperCase(),
        minmov: 1,
        pricescale: pricescaleValue,
        has_intraday: true,
        intraday_multipliers: [
          '1',
          '5',
          '15',
          '30',
          '60',
          '120',
          '240',
          '360',
          '720',
          '1440',
          '4320',
        ],
        supported_resolutions: ['1', '5', '15', '30', '60', '120', '240', '360', '720', '1D', '3D'],
        volume_precision: 8,
        data_status: 'streaming',
      };

      return setTimeout(() => onSymbolResolvedCallback(symbolStub), 0);
    },

    getBars: async (
      symbolInfo,
      resolution,
      from,
      to,
      onHistoryCallback,
      onErrorCallback,
      firstDataRequest,
    ) => {
      const split_data = symbolInfo.name.split('/');

      if (resolution === '1D') {
        resolution = 1440;
      } else if (resolution === 'D') {
        resolution = 4320;
      } else if (resolution.includes('W')) {
        resolution = 10080;
      }

      console.log(resolution);
      
      const url = `${process.env.REACT_APP_STAGE_API_URL}graph/v1/graph/user/graph_data?pairName=${(split_data[0] + "_" + split_data[1]).toLowerCase()}&interval=${resolution}&limit=1000&fromDate=${from}&toDate=${to}`;

      // const newData = DATAFEED;

      // const bars = [];
      // let coeff = resolution * 60;

      // for (let i = 0; i < newData?.t?.length; i++) {
      //   let rounded = Math.floor(newData.t[i] / coeff) * coeff;
      //   bars.push({
      //     time: rounded * 1000,
      //     low: Number(newData.l[i]),
      //     high: Number(newData.h[i]),
      //     open: Number(newData.o[i]),
      //     close: Number(newData.c[i]),
      //     volume: Number(newData.v[i]),
      //   });
      // }
      // if (bars?.length < 1) {
      //   onHistoryCallback([], { noData: true });
      // } else {
      //   onHistoryCallback(bars, { noData: false });
      // }

      return fetch(url)
      .then((response) => response.json())
      .then((data) => {
        if (!data || data === 'Error') {
          onHistoryCallback([], { noData: true });
        }

        if (data) {
          const newData = data?.data;
          const bars = [];
          let coeff = resolution * 60;
          for (let i = 0; i < newData?.t?.length; i++) {
            let rounded = Math.floor(newData.t[i] / coeff) * coeff;
            bars.push({
              time: rounded * 1000,
              low: Number(newData.l[i]),
              high: Number(newData.h[i]),
              open: Number(newData.o[i]),
              close: Number(newData.c[i]),
              volume: Number(newData.v[i]),
            });
          }
          if (bars?.length < 1) {
            onHistoryCallback([], { noData: true });
          } else {
            onHistoryCallback(bars, { noData: false });
          }
        }
      })
      .catch((err) => {
        onHistoryCallback([], { noData: true });
      });
    
    },

    subscribeBars: (
      symbolInfo,
      resolution,
      onRealtimeCallback,
      subscribeUID,
      onResetCacheNeededCallback,
    ) => {
      if (resolution === '1D') {
        resolution = 1440;
      } else if (resolution === 'D') {
        resolution = 4320;
      } else if (resolution.includes('W')) {
        resolution = 10080;
      }
      let coeff = resolution * 60;
      dataFeed.onRealtimeCallback = (kline) => {
        let rounded = Math.floor(kline.t / coeff) * coeff;
        if (Object.keys(kline).length > 0) {
          const newKlineData = {
            time: rounded * 1000,
            low: Number(kline.l),
            high: Number(kline.h),
            open: Number(kline.o),
            close: Number(kline.c),
            volume: Number(kline.v),
          };
          onRealtimeCallback(newKlineData);
        }
      };
    },

    unsubscribeBars: (subscribeUID) => {
    //   const { marketId, periodString } = tradingChart.currentKlineSubscription;

    //   if (marketId && periodString) {
    //     tradingChart.props.unSubscribeKline(marketId, periodString);
    //   }

    //   tradingChart.setCurrentKlineSubscription({});
    },

    onRealtimeCallback: (kline) => {
      // window.console.log(`default onRealtimeCallback called with ${JSON.stringify(bar)}`);
    },
  };

  return dataFeed;
};
